<template>
  <e-dialog
    :dialog-title="dialogTitle"
    :center-dialog-visible="applyVisible"
    :popup-width="popupWidth"
    :close-btn="closeBtn"
    :destroy-close="true"
    :modal-append-to-body="true"
    :only-show-cancel="onlyShowCancel"
    :cancel-button-tip="cancelButtonTip"
    @resetPopupData="resetPopupData"
    @submitPopupData="submitPopupData"
  >
    <!-- 缺接口 返回申请公司 -->
    <div
      v-if="applyForm.filingStatus === 1 && !applyForm.messageType"
      class="tip"
    >
      <span>提示：</span>该客户已被申请备案，正在公示中
    </div>
    <el-form
      v-if="applyForm.messageType === 0"
      ref="form"
      :model="applyForm"
      label-width="90px"
      class="form"
    >
      <el-form-item label="客户名称：">
        <span>{{ applyForm.resourceCompanyName }}</span>
      </el-form-item>
      <el-form-item label="申请公司：">
        <span>{{ applyForm.filingCompanyName }}</span>
      </el-form-item>
      <el-form-item label="申请理由：">
        <el-input
          v-model="applyForm.applyReson"
          :rows="5"
          maxlength="300"
          show-word-limit
          placeholder="请输入内容"
          type="textarea"
        ></el-input>
      </el-form-item>
      <el-form-item label="附件：" style="margin-top: 18px">
        <!-- <FileUpload
          :fileSize="20"
          :uploadUrl="uploadUrl"
          @getFileInfo="getFileInfo"
          :tipsMessage="tipsMessage"
          accept=".xlsx, .xls, .pdf, .doc, .docx, .rar, .zip"
        >
          <template #tip>
            {{ tipsMessage }}
          </template>
        </FileUpload> -->
        <eui-upload
          :action="uploadUrl"
          :headers="headers"
          show-file-list
          :file-size="20"
          accept=".xlsx,.xls,.pdf,.doc,.docx,.rar,.zip"
          single
          text="上传附件"
          tip="20M以内，仅上传一个附件，格式excel、pdf、word、rar、zip"
          @handleSuccess="uploadSuccess"
        >
        </eui-upload>
        <!-- <span>20M以内，仅上传一个附件，格式excel、pdf、word、rar、zip</span> -->
      </el-form-item>
    </el-form>

    <div v-if="applyForm.messageType === 1">
      您当前备案客户（含备案成功、申请中、公示中）中有10家客户未配置组织架构，请先督促客户配置完成后，再进行新客户备案申请！
    </div>
    <div v-if="applyForm.messageType === 2">
      <p>
        {{
          `您当前对该客户的备案申请受限，限制解除时间：${applyForm.lastLimitTime}。受限原因：【${applyForm.reason}】`
        }}
      </p>
      <p style="margin-top: 10px">如有疑问，请咨询易派客工作人员。</p>
    </div>
    <div v-if="applyForm.messageType === 3">
      您当前对该客户的备案申请正在审核中，请等待审核，您可以在备案查询中查看审核进展。
    </div>
  </e-dialog>
</template>

<script>
import EDialog from '@/components/common/e-dialog';
import Api from '@/modules/projectA/api/filing';
import { epecToken } from '@/modules/projectA/utils/globalData';

export default {
  components: {
    EDialog,
  },
  props: {
    applyVisible: {
      type: Boolean,
      default: false,
    },
    applyForm: {
      type: Object,
      default: () => ({
        applyReson: '',
      }),
    },
  },
  data() {
    return {
      dialogTitle: '申请备案',
      closeBtn: true,
      popupWidth: '600px',
      uploadUrl: '',
      tipsMessage: '20M以内，仅上传一个附件，格式excel、pdf、word、rar、zip',
      headers: epecToken,
      /* privateUpload: {
        keyName: 'filePath',
        url: Api.uploadFilingApplyFile(),
        method: 'get',
      }, */
      onlyShowCancel: false,
      cancelButtonTip: '取消',
    };
  },
  /* watch: {
    applyVisible(newVal) {
      if (newVal) {
        console.log(this.applyForm.messageType, 'this.applyForm.messageType ');
        this.closeBtn = this.applyForm.messageType !== 0;
        if (this.closeBtn) {
          this.dialogTitle = '提示';
        } else {
          this.dialogTitle = '申请备案';
        }
      }
    },
  }, */
  mounted() {
    this.uploadUrl = Api.uploadFilingApplyFile();
    console.log(this.applyForm.messageType, 'this.applyForm.messageType ');
    this.onlyShowCancel = this.applyForm.messageType !== 0;
    if (this.onlyShowCancel) {
      this.dialogTitle = '提示';
      this.cancelButtonTip = '我知道了';
      this.popupWidth = '420px';
    } else {
      this.dialogTitle = '申请备案';
      this.cancelButtonTip = '取消';
      this.popupWidth = '580px';
    }
  },
  methods: {
    uploadSuccess(file) {
      console.log(file, 'file');
      if (file.code === '200') {
        const { data } = file;
        this.applyForm.attachName = data.fileName;
        this.applyForm.attachPath = data.url;
      }
    },
    getFileInfo(fileList) {
      const [fileData] = fileList;
      this.applyForm.attachName = fileData.fileName;
      this.applyForm.attachPath = fileData.fileUrl;
    },
    // 关闭弹窗事件
    resetPopupData() {
      this.$emit('update:applyVisible', false);
    },
    // 提交事件
    async submitPopupData() {
      const {
        applyReson,
        attachName,
        attachPath,
        filingCompanyId,
        filingCompanyName,
        resourceId,
      } = this.applyForm;
      const result = await Api.addFilingApply({
        applyReson,
        attachName,
        attachPath,
        filingCompanyId,
        filingCompanyName,
        filingType: 2,
        resourceId,
      });
      if (result.code === '200') {
        this.resetPopupData();
        this.$message.success('申请成功');
        this.$emit('refresh');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.tip {
  background: #e8efff;
  padding: 15px 0 15px 10px;
  span {
    color: #f0250f;
  }
}
.form {
  margin-top: 10px;
  .el-form-item--small.el-form-item {
    margin-bottom: 10px;
  }
  .el-form-item__content {
    width: auto;
  }
  ::v-deep .el-textarea__inner {
    border-radius: 0;
  }
}
</style>
